import { SearchCriteria } from 'src/app/core/interfaces/search-criteria.interface';
import { CollectionFinderItemDTO } from 'src/app/core/interfaces/collection.interface';
import { FIELD_PRIORITY_WEIGHT, SEARCH_FIELD, SearchPriorityConfig } from 'src/app/core/interfaces/search-priority-config';

export class CollectionDescriptionCriteria implements SearchCriteria {
  getMatchScore(_collection: CollectionFinderItemDTO, _query: string): number {
    return [_collection.description, ...(_collection.translatedDescriptions ?? [])]
      .some((_text) => _text?.toLowerCase().includes(_query)) ? 1 : 0;
  }

  getRelevanceFieldWeightAndMatchScore(_collection: CollectionFinderItemDTO, _query: string): SearchPriorityConfig {
      return {
        relevanceField: SEARCH_FIELD.DESCRIPTION,
        fieldPriorityWeight: FIELD_PRIORITY_WEIGHT.DESCRIPTION,
        matchScore: this.getMatchScore(_collection, _query)
      }
    }
}
